import React from 'react';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IconRow from '../components/IconRow';
import {SMALL_ICONS_PER_ROW} from '../settings';

export const SIZE_SMALL = 56;
export const SIZE_LARGE = 112;

export default {
  propTypes: {
    workingSetIcons: ImmutablePropTypes.listOf(
      ImmutablePropTypes.record
    ),
    iconSetIdsInSubscription: ImmutablePropTypes.listOf(
      PropTypes.number
    ).isRequired,
    iconSetsByIconId: ImmutablePropTypes.map,
    onIconSelected: PropTypes.func.isRequired,
    onIconDeselected: PropTypes.func.isRequired,
    onRequestToBuy: PropTypes.func.isRequired,
    onRequestToUpgrade: PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      focused: null,
    };
  },

  handleIconFocused(icon) {
    this.setState({
      focused: icon,
    });
  },

  renderIcons(icons, size, options = {}) {
    const optionsWithDefaults = Object.assign(
      {},
      {rowCount: SMALL_ICONS_PER_ROW, addIconSetName: false, highlightedIconNames: Map()},
      options
    );
    const iconElements = [];
    const pushElements = (num, iconsSlice, rowKey = 0) => {
      iconElements.push(
        <IconRow
          key={rowKey}
          rowKey={rowKey}
          icons={iconsSlice.take(num)}
          size={size}
          options={optionsWithDefaults}
          workingSetIcons={this.props.workingSetIcons}
          iconSetIdsInSubscription={this.props.iconSetIdsInSubscription}
          iconSetsByIconId={this.props.iconSetsByIconId}
          onIconSelected={this.props.onIconSelected}
          onIconDeselected={this.props.onIconDeselected}
          onRequestToBuy={this.props.onRequestToBuy}
          onRequestToUpgrade={this.props.onRequestToUpgrade}
        />
      );

      if (iconsSlice.size > num) {
        pushElements(num, iconsSlice.skip(num), rowKey + 1);
      }
    };

    pushElements(optionsWithDefaults.rowCount, icons);

    return iconElements;
  },
};



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/mixins/IconMixin.js